import { Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { ResetPasswordRequestmodel } from "src/app/components/admin/user-management/pages/user-management/user-management.model";
import { UserManagementService } from "src/app/components/admin/user-management/pages/user-management/user-management.service";
import { Button } from "src/app/shared/model/enum";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
  providers: [NgbActiveModal],
})
export class ResetPasswordComponent implements OnInit {
  hidePassword1: boolean = false;
  hidePassword2: boolean = false;
  passwordForm: FormGroup;
  submitted = false;
  userEmail: any;
  ResetPasswordRequestmodel = new ResetPasswordRequestmodel();
  passSuccess: boolean = false;
  enumButtonName = Button;
  passwordErrors: string = "";
  confirmPasswordErrors: string = "";
  isError: boolean = false;
  passwordTouched: boolean = false;
  confirmPasswordTouched: boolean = false;
  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private activateRouter: ActivatedRoute,
    public userManagementService: UserManagementService,
    private toastr: ToastrService
  ) {
    this.passwordForm = this.fb.group(
      {
        password: new FormControl("", Validators.required),
        confirmPassword: new FormControl("", Validators.required),
      },
      {
        validators: this.match("password", "confirmPassword"),
      }
    );
  }

  ngOnInit(): void {
    this.activateRouter.queryParams.subscribe((params) => {
      this.userEmail = params["email"];
    });
  }

  //reset-password post
  resetPassword() {
    if (this.passwordForm.valid && !this.confirmPasswordErrors && !this.passwordErrors) {
      this.ResetPasswordRequestmodel.email = this.userEmail;
      this.userManagementService
        .adminResetPassword(this.ResetPasswordRequestmodel)
        .subscribe((data) => {
          if (data.isSuccess === true) {
            this.toastr.success(data.message);
            this.ResetPasswordRequestmodel = new ResetPasswordRequestmodel();
            this.passSuccess = true;
            this.activeModal.close("success");
          }
        });
    } else {
      this.submitted = true;
    }
  }
  //reset-password

  match(controlName: string, checkControlName: string): ValidatorFn {
    return (controls: AbstractControl) => {
      const control = controls.get(controlName);
      const checkControl = controls.get(checkControlName);

      if (!control || !checkControl) return null;

      // If another validator has already found an error on the matchingControl, return
      if (checkControl.errors && !checkControl.errors["match"]) {
        return null;
      }

      // Compare values
      if (control.value !== checkControl.value) {
        checkControl.setErrors({ match: true });
      } else {
        // ✅ Clear match error when both are equal
        checkControl.setErrors(null);
      }

      return null;
    };
  }

  get password() {
    return this.passwordForm.get("password") as FormControl;
  }
  get confirmPassword() {
    return this.passwordForm.get("confirmPassword") as FormControl;
  }
  validatePassword(field: "password" | "confirmPassword", value: string) {
    if (field === "password") {
      this.ResetPasswordRequestmodel.newPassword = value;
      this.passwordTouched = true;
    } else {
      this.ResetPasswordRequestmodel.confirmNewPassword = value;
      this.confirmPasswordTouched = true;
    }
    let errorMessage = "";

    if (value && value.trim() !== "") {
      if (!/[A-Z]/.test(value)) {
        errorMessage = "Must contain at least one uppercase letter.";
      } else if (!/[0-9]/.test(value)) {
        errorMessage = "Must contain at least one numeric digit.";
      } else if (!/[^a-zA-Z0-9]/.test(value)) {
        errorMessage = "Must contain at least one special character.";
      }
    } else {
      errorMessage = "";
    }

    if (field === "password") {
      this.passwordErrors = this.passwordTouched ? errorMessage : "";
    } else {
      this.confirmPasswordErrors = this.confirmPasswordTouched
        ? errorMessage
        : "";
    }

    this.isError = !!(this.passwordErrors || this.confirmPasswordErrors);
  }
}
